import { render, staticRenderFns } from "./Block.vue?vue&type=template&id=5ecaf845&scoped=true&lang=pug"
import script from "./Block.vue?vue&type=script&lang=js"
export * from "./Block.vue?vue&type=script&lang=js"
import style0 from "./Block.vue?vue&type=style&index=0&id=5ecaf845&prod&lang=scss"
import style1 from "./Block.vue?vue&type=style&index=1&id=5ecaf845&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ecaf845",
  null
  
)

export default component.exports